import React from 'react';
import { Divider as MuiDivider } from '@mui/material';
import { OverridableStyles } from '../../../utils/types.ts';

export interface DividerProps extends OverridableStyles {
  orientation?: 'vertical' | 'horizontal';
  variant?: 'fullWidth' | 'inset' | 'middle';
  flexItem?: boolean;
}

const Divider: React.FC<DividerProps> = ({
  orientation,
  variant,
  flexItem,
  styleOverrides,
}) => (
  <MuiDivider
    orientation={orientation}
    variant={variant}
    flexItem={flexItem}
    sx={styleOverrides}
  />
);

export default Divider;
